/*
  Lifecycle hook providing the ability to check a component's mount state.
  Returns a function that will return true if the component mounted and false otherwise.

  const isMounted = useMountedState();

  setTimeout(() => {
    if (isMounted()) {
      // ...
    } else {
      // ...
    }
  }, 1000);
*/

import { useCallback, useEffect, useRef } from 'react';

export const useMountedState = () => {
  const mountedRef = useRef<boolean>(false);
  const get = useCallback(() => mountedRef.current, []);

  useEffect(() => {
    mountedRef.current = true;

    return () => {
      mountedRef.current = false;
    };
  }, []);

  return get;
};
